import { render, staticRenderFns } from "./TrialCancellationPlanSurvey.vue?vue&type=template&id=16889f88&"
import script from "./TrialCancellationPlanSurvey.vue?vue&type=script&lang=ts&"
export * from "./TrialCancellationPlanSurvey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16889f88', component.options)
    } else {
      api.reload('16889f88', component.options)
    }
    module.hot.accept("./TrialCancellationPlanSurvey.vue?vue&type=template&id=16889f88&", function () {
      api.rerender('16889f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/cancellation/TrialCancellationPlanSurvey.vue"
export default component.exports